/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка
 */
export interface Error {
  /** Код ошибки */
  errorCode?: "OK" | "ERROR";

  /** Описание ошибки */
  errorDesc?: string;
}

export interface ErrorResponse {
  /** Список ошибок */
  errorList?: Error[];
}

/**
 * Информация о сертификате
 */
export interface CertificateView {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Исходное имя загруженного файла */
  filename?: string;

  /** Серийный номер */
  serialNumber?: string;

  /** Статус */
  status?:
    | "NEW"
    | "IN_PROCESS"
    | "ACCEPTED"
    | "PROCESS_ERROR"
    | "REMOVE"
    | "ON_REMOVING"
    | "REMOVED_EXTERNAL"
    | "REMOVE_ERROR"
    | "REMOVED";

  /**
   * Дата создания
   * @format date-time
   */
  created?: string;

  /** Id клиента */
  clientId?: string;

  /**
   * Id загруженного файла в ФХ
   * @format uuid
   */
  extId?: string;

  /**
   * Размер файла в МБ
   * @format int64
   */
  fileSize?: number;

  /** Публичные данные сертификата */
  fileDtls?: string;

  /** Отображения файла в Kb, Mb */
  fileSizeMb?: string;

  /** Статус загрузки файла */
  statusUpload?: string;

  /** Описание ошибки загрузки файла */
  errorUpload?: string;

  /** Текстовое представление для поля status */
  statusTitle?: string;
}

export interface PagedResultCertificateView {
  content?: CertificateView[];

  /** @format int32 */
  totalRecord?: number;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-ms-h2h
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-ms-h2h.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=199500721)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Метод загрузки сертификата
     *
     * @tags Сервис управления сертификатами
     * @name Create
     * @request POST:/api/h2h/v1/external/certificate
     * @secure
     */
    create: (data: { file: File }, params: RequestParams = {}) =>
      this.request<CertificateView, ErrorResponse>({
        path: `/api/h2h/v1/external/certificate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения списка сертификатов
     *
     * @tags Сервис управления сертификатами
     * @name Find
     * @request GET:/api/h2h/v1/external/certificate/find
     * @secure
     */
    find: (
      query?: {
        statuses?: string;
        statusGroup?: string;
        createdFrom?: string;
        createdTo?: string;
        page?: string;
        size?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PagedResultCertificateView, ErrorResponse>({
        path: `/api/h2h/v1/external/certificate/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Удаление сертификата (Помечается удаленным)
     *
     * @tags Сервис управления сертификатами
     * @name DeleteById
     * @request DELETE:/api/h2h/v1/external/certificate/{id}
     * @secure
     */
    deleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/h2h/v1/external/certificate/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
